import { render } from "./AgrupadosAsegurador.vue?vue&type=template&id=cb353f76&scoped=true"
import script from "./AgrupadosAsegurador.vue?vue&type=script&lang=js"
export * from "./AgrupadosAsegurador.vue?vue&type=script&lang=js"

import "./AgrupadosAsegurador.vue?vue&type=style&index=0&id=cb353f76&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb353f76"]])

export default __exports__